var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import "./style.scss";
import { HDSStep, HDSStepper } from "@here/hds-react-components/Stepper";
import { StepperDefaultPropsValues } from "./constant";
export var Stepper = memo(function (props) {
    var steps = props.steps, onStepStateChange = props.onStepStateChange, activeStep = props.activeStep, completedStep = props.completedStep;
    var handleOnStepChange = function (stepState) {
        onStepStateChange === null || onStepStateChange === void 0 ? void 0 : onStepStateChange(stepState);
    };
    return (_jsx("div", __assign({ className: "stepper-container", "data-testid": "custom-stepper" }, { children: _jsx(HDSStepper, __assign({ activeStep: activeStep, completeStep: completedStep, nonLinear: false, onStepStateChange: handleOnStepChange }, { children: steps.map(function (step) {
                return (_jsx(HDSStep, { label: step.label }, "".concat(step.stepNumber, "-").concat(step.label)));
            }) })) })));
});
Stepper.displayName = "Stepper";
Stepper.defaultProps = __assign({}, StepperDefaultPropsValues);
